export const RATES_ENDPOINT_OP_MAINNET = `https://subgraph.satsuma-prod.com/${process.env.NEXT_PUBLIC_SATSUMA_API_KEY}/kwenta/optimism-latest-rates/api`;
// TODO Update this to the correct Sepolia endpoint
export const RATES_ENDPOINT_OP_SEPOLIA = `https://subgraph.satsuma-prod.com/${process.env.NEXT_PUBLIC_SATSUMA_API_KEY}/kwenta/optimism-sepolia-latest-rates/api`;
export const RATES_ENDPOINTS = {
    10: RATES_ENDPOINT_OP_MAINNET,
    11155420: RATES_ENDPOINT_OP_SEPOLIA,
};
export const getRatesEndpoint = (networkId) => {
    return RATES_ENDPOINTS[networkId] || RATES_ENDPOINTS[10];
};
